import React, { ReactNode } from 'react';

import { CardImageLoading } from '../CardImageLoading';

type TCardImageProps = {
  value: string;
  children: ReactNode;
  type?: string;
};

export const CardImageBackground = ({
  value,
  children,
  type,
}: TCardImageProps) => {
  const style = {
    backgroundImage: `linear-gradient(0deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.15)),url(${value})`,
  };

  const className = `vitrine-template2__card--image${
    type !== 'VENDA_SHOPPING_GOP' ? ' vitrine-template2__card--image--full' : ''
  }`;

  return (
    <div className={className} style={style}>
      {!value && <CardImageLoading />}
      {children}
    </div>
  );
};
